<template>
    <div class="video-container">
        <div class="d-flex align-items-start">
            <h2 class="video-container-title" style="flex: 1 0 50%"> {{currentV.title}} </h2>
            <span @click="back" class="btn btn-outline-primary btn-sq btn-flat"><font-awesome-icon icon="arrow-left" class="mr-3" />back</span>
        </div>
        <hr>
        <iframe 
            ref="iframe"
            :src="`https://www.youtube.com/embed/${currentV.ytId}`"
            frameborder="0" 
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
            >
        </iframe>
    </div>
</template>

<script>
export default {
    props: ['currentV'],
    data() {
        return {
        }
    },
    methods: {
        setIframeH() {
            let iframe = this.$refs.iframe
            var iframeW = iframe.offsetWidth
			let iframeH = Math.round(iframeW/(560/315))
			iframe.height = iframeH
        },
        back() {
            this.$emit('back')
        }
    },
    mounted() {
        this.setIframeH()
        window.addEventListener('resize', this.setIframeH)
    },
    destroyed() {
        window.removeEventListener('resize', this.setIframeH)
    },
}
</script>

<style lang="scss">
    .video-container{
        flex: 1 0 100%;
        height: auto;

        &-title {
            margin-bottom: 0;
            position: relative;
            color: #5a7b92;
        }
        hr{
            margin: 30px 0 50px
        }
    }
    iframe {
        display: block;
        width: 100%;
        margin: 0 auto;
        border: 5px solid #ddd
    }
    
    @media (min-width: 1200px){
        iframe {
            width: 80%;
        }
    }
</style>